import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToolbarStateService {
  private siteSubject = new BehaviorSubject<number>(0);
  site$ = this.siteSubject.asObservable();

  ChangeSite(site: number) {
    if(site){
      localStorage.setItem('fksite', site.toString());
      this.siteSubject.next(site);
    }
  }
}
